module.exports = __webpack_public_path__ + "media/images/conspiracy_myths/ihra-cd2f968a2354d56e1065e9d46b0051e0.png";